






import { computed, defineComponent } from '@nuxtjs/composition-api';
import { usePageStore } from '~/stores/page';

import ARTICLE from '~/modules/articles/pages/ArticlePage.vue';
import ARTICLE_CATEGORY from '~/modules/articles/pages/ArticlesListPage.vue';
import CMS_PAGE from '~/pages/Cms.vue';

export default defineComponent({
  name: 'PageResolver',
  components: {
    CMS_PAGE,
    ARTICLE_CATEGORY,
    ARTICLE,
  },
  middleware: ['url-resolver'],
  setup() {
    const { routeData } = usePageStore();

    const type = computed(() => routeData?.type);

    return {
      type,
    };
  },
});
